import React, { ReactNode } from 'react';
type Props = {
    children: ReactNode;
}
export default function Col100(props: Props): JSX.Element {
    const { children } = props;
    return (
        <section className="elementor-section elementor-inner-section elementor-element elementor-element-f3fe4d5 elementor-section-boxed elementor-section-height-default elementor-section-height-default" data-element_type="section">
            <div className="elementor-container elementor-column-gap-default">
                <div className="elementor-row">
                    <div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-a4a3871">
                        <div className="elementor-column-wrap elementor-element-populated">
                            <div className="elementor-widget-wrap">
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}